import type { UserScope } from '@/models/users'
import type { DialogOptions } from 'vuejs-dialog/types'

declare module 'vue/types/vue' {
  // TODO: add more from https://github.com/Godofbrowser/vuejs-dialog
  interface Dialog {
    confirm: (text: string, options?: Partial<DialogOptions>) => Promise<void>
    registerComponent: (name: string, component: VueConstructor<Vue>) => void
  }

  type UseConfirmDialog = (
    data: string | [string, Partial<DialogOptions>],
    callback?: () => any,
    condition?: boolean,
  ) => void

  interface Vue {
    $dialog: Dialog
    $useConfirmDialog: UseConfirmDialog
  }

  interface VueConstructor {
    dialog: Dialog
    useConfirmDialog: UseConfirmDialog
  }
}

export interface Point {
  x: number
  y: number
}

export interface Position extends Point {
  top: number
  left: number
}

export enum AppColor {
  Purple = '5e45b5',
  Green = '27ae60',
  Red = 'eb5757',
  Orange = 'f2994a',
  Blue = '5db0ff',
}

export interface GridColumn {
  name:
    | 'status'
    | 'id'
    | 'title'
    | 'steps'
    | 'duration'
    | 'pass'
    | 'target'
    | 'conversion'
    | 'menu'
    | 'buttons'
  type: 'Status' | 'Number' | 'String' | 'Duration' | 'Menu' | 'Button'
  width: string
  title: string
  label: string
  test: boolean
  show: boolean
  sortable: boolean
  scope: UserScope
}
